import React, { Component } from 'react'
import { Card } from 'react-toolbox/lib/card'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'redux'
import { NB_PARTNER_SITE_DATA, NB_PARTNER_SITE_CATEGORIES, NB_TRENDLINE_DATA, NB_TRENDLINE_CATEGORIES } from './constantsNB'
import Bar from 'components/custom/Highcharts/Bar'
import { Flex } from 'reflexbox'
import Panel from 'containers/Report/Dashboard/Panel'
import Layout from 'containers/Report/Dashboard/Layout'
import Trendline from './Trendline'

class Email extends Component {


  aeResourceCapacity = () => {
    return (
        <table styleName="aeResourceCap">
            <thead>
                <tr>
                    <th></th>
                    <th>Taiwan</th>
                    <th>Shanghai</th>
                    <th>Korea</th>
                    <th>Total</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Available Resources (%)</td>
                    <td>66.0</td>
                    <td>79.2</td>
                    <td>100</td>
                    <td>69.5</td>
                </tr>
                <tr>
                    <td>Available Projects</td>
                    <td>99 to 264</td>
                    <td>42 to 112</td>
                    <td>5 to 10</td>
                    <td>141 to 376</td>
                </tr>
            </tbody>
        </table>
    )
  }

  activeOnGoing = () => {
    return (
        <table styleName="activeOnGoing">
            <thead>
                <tr>
                    <th></th>
                    <th>Taiwan</th>
                    <th>Shanghai</th>
                    <th>Korea</th>
                    <th>Total</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>GeForce GN-18</td>
                    <td>1</td>
                    <td>2</td>
                    <td>3</td>
                    <td>6</td>
                </tr>
                <tr>
                    <td>GeForce GN-20</td>
                    <td>20</td>
                    <td>30</td>
                    <td>40</td>
                    <td>90</td>
                </tr>
                <tr styleName="total">
                    <td>GeForce Total</td>
                    <td>21</td>
                    <td>32</td>
                    <td>43</td>
                    <td>96</td>
                </tr>
                <tr>
                    <td>Quadro QN-20</td>
                    <td>1</td>
                    <td>2</td>
                    <td>3</td>
                    <td>6</td>
                </tr>
                <tr>
                    <td>Quadro EN-20</td>
                    <td>20</td>
                    <td>30</td>
                    <td>40</td>
                    <td>90</td>
                </tr>
                <tr styleName="total">
                    <td>Quadro Total</td>
                    <td>21</td>
                    <td>32</td>
                    <td>43</td>
                    <td>96</td>
                </tr>
            </tbody>
        </table>
    )
  }

  partnerSiteChart = () => {
      return (
        <Bar
          title={""}
          data={NB_PARTNER_SITE_DATA}
          categories={NB_PARTNER_SITE_CATEGORIES}
        />
      )
  }

  aeCapacityTrendline = () => {
    return (
      <Trendline
        title={""}
        data={NB_TRENDLINE_DATA}
        categories={NB_TRENDLINE_CATEGORIES}
      />
    )
}
  
  render() {

    return (
        <Layout>
        <Panel>

        <div styleName="wrapper">
            <Card theme={styles}>
                <div styleName="logo">
                    <img styleName='img' src='/images/email_banner.png'/>
                </div>
                <div styleName="title">
                    <h1>AE Dashboard Report - Notebook</h1>
                    <p>5/28/2022</p>
                </div>
                <div styleName="pretext">
                    <p>Irene Liao, here is your weekly Fulcrum Notebook report. </p>
                    <p styleName="moreInfo">For more information, please visit <a href="https://fulcrum.nvidia.com/report/dashboard">Fulcrum Dashboard</a>.</p>
                </div>
                <div styleName="tableOfContent">
                    <ul>
                        <li><a href="#">AE Resource Capacity</a></li>
                        <li><a href="#">Active Projects</a></li>
                        <li><a href="#">AE Resource Capacity Trendline</a></li>
                        <li><a href="#">Projects Life Cycle by Partner Site</a></li>
                    </ul>
                </div>
                <div styleName="graph">
                    <h4>AE Resource Capacity</h4>
                    <div>{this.aeResourceCapacity()}</div>
                </div>
            
                <div styleName="ending">
                    <div><p styleName="question">Questions?</p></div>
                    <div><p>For any issues, please email <a href='fulcrum-help@nvidia.com'>fulcrum-help@nvidia.com</a></p></div>
                </div>
                <div styleName="reason">
                    You are receiving this email because you are a support team member of at least one Notebook project on Fulcrum
                </div>
            </Card>
        </div>
        </Panel>

        </Layout>
    )
  }
}
const withStyles = CSSModules(styles)
const enhance = compose(
    withStyles
  )
export default enhance(Email)
